export default {
  zh: {
    find: 'Find',
    inviteHistory: 'Invite History',
    inviteID: 'Inviter ID',
    invitees: 'Invitees',
    timeInvited: 'Time Invited',
    id: 'ID',
    enterID: 'Enter the Agency ID',
    notExist: 'The agency does not exist',
    successful: 'The operation was successful',
    haveHost: 'The user joined another guild',
    apply: 'Apply'
  },
  en: {
    find: 'Find',
    inviteHistory: 'Invite History',
    inviteID: 'Inviter ID',
    invitees: 'Invitees',
    timeInvited: 'Time Invited',
    id: 'ID',
    enterID: 'Enter the Agency ID',
    notExist: 'The agency does not exist',
    successful: 'The operation was successful',
    haveHost: 'The user joined another guild',
    apply: 'Apply',
    hadApplyText: "You cannot apply again, waiting App' admin review"
  },
  ar: {
    // 阿拉伯
    find: 'وجد',
    inviteHistory: 'دعوة السجل',
    inviteID: 'ايدي المدعو',
    invitees: 'المدعوون ',
    timeInvited: 'وقت الدعوة ',
    id: 'معرف',
    enterID: 'أدخل رقم الوكالة',
    notExist: 'الوكالة غير موجودة',
    successful: 'العملية كانت ناجحه',
    haveHost: 'انضم المستخدم إلى نقابة أخرى',
    apply: 'تقديم',
    hadApplyText: 'لا يمكن التقديم مجدداً، يرجى انتظار المراجعة من مشرف تشاتي '
  },
  tr: {
    //土耳其
    find: 'Bul',
    inviteHistory: 'Davet Geçmişi',
    inviteID: 'Davet Eden Kimliği',
    invitees: 'Davetliler',
    timeInvited: 'Davet Edilen Zaman',
    id: 'KİMLİĞİ',
    enterID: 'Ajans ID Girin',
    notExist: 'Ajans mevcut değil',
    successful: 'İşlem Başarılı Oldu',
    haveHost: 'Kullanıcı başka bir loncaya katıldı',
    apply: 'Uygula',
    hadApplyText: "Tekrar başvuramazsınız, App'nin yönetici incelemesi bekleniyor"
  },
  pt: {
    find: 'Encontrar',
    inviteHistory: 'Histórico de Convites',
    inviteID: 'ID do Convidante',
    invitees: 'Convidados',
    timeInvited: 'Hora do Convite',
    id: 'ID',
    enterID: 'Digite o ID da Agência',
    notExist: 'A agência não existe',
    successful: 'A operação foi bem-sucedida',
    haveHost: 'O usuário entrou em outra guilda',
    apply: 'Aplicar',
    hadApplyText: 'Você não pode se inscrever novamente, aguardando a revisão do administrador do App'
  },
  id: {
    find: 'Temukan',
    inviteHistory: 'Sejarah Undangan',
    inviteID: 'ID Pengundang',
    invitees: 'Yang Diundang',
    timeInvited: 'Waktu Diundang',
    id: 'ID',
    enterID: 'Masukkan ID Agensi',
    notExist: 'Agensi tidak ada',
    successful: 'Operasi berhasil',
    haveHost: 'Pengguna telah bergabung dengan guild lain',
    apply: 'Lamar',
    hadApplyText: 'Anda tidak dapat melamar lagi, menunggu tinjauan admin App'
  },
  uz: {
    find: 'Topish',
    inviteHistory: 'Taklif Tarixi',
    inviteID: 'Taklif qilgan ID',
    invitees: 'Taklif qilinganlar',
    timeInvited: 'Taklif qilish vaqti',
    id: 'ID',
    enterID: 'Agentlik ID sini kiriting',
    notExist: 'Agentlik mavjud emas',
    successful: 'Amaliyot muvaffaqiyatli bajarildi',
    haveHost: "Foydalanuvchi boshqa bir gildiyaga qo'shildi",
    apply: 'Ariza berish',
    hadApplyText: "Siz qayta ariza bera olmaysiz, App adminining ko'rib chiqishini kutyapsiz"
  },
  ru: {
    find: 'Найти',
    inviteHistory: 'История приглашений',
    inviteID: 'ID пригласившего',
    invitees: 'Приглашенные',
    timeInvited: 'Время приглашения',
    id: 'ID',
    enterID: 'Введите ID агентства',
    notExist: 'Агентство не существует',
    successful: 'Операция прошла успешно',
    haveHost: 'Пользователь присоединился к другой гильдии',
    apply: 'Подать заявку',
    hadApplyText: 'Вы не можете подать заявку снова, ожидайте проверку администратора App'
  },
  fa: {
    find: 'یافتن',
    inviteHistory: 'تاریخ دعوت',
    inviteID: 'ID دعوت کننده',
    invitees: 'دعوت شدگان',
    timeInvited: 'زمان دعوت',
    id: 'ID',
    enterID: 'ID آژانس را وارد کنید',
    notExist: 'آژانس وجود ندارد',
    successful: 'عملیات با موفقیت انجام شد',
    haveHost: 'کاربر به یک گیلد دیگر پیوسته است',
    apply: 'درخواست دادن',
    hadApplyText: 'شما نمی توانید دوباره درخواست دهید، منتظر بررسی مدیر App هستید'
  },
  ur: {
    find: 'تلاش کریں',
    inviteHistory: 'دعوت کی تاریخ',
    inviteID: 'دعوت دہندہ کی آئی ڈی',
    invitees: 'مدعو افراد',
    timeInvited: 'دعوت کا وقت',
    id: 'آئی ڈی',
    enterID: 'ایجنسی آئی ڈی درج کریں',
    notExist: 'ایجنسی موجود نہیں ہے',
    successful: 'عمل کامیاب رہا',
    haveHost: 'صارف نے کسی اور گیلڈ میں شمولیت اختیار کر لی ہے',
    apply: 'درخواست دیں',
    hadApplyText: 'آپ دوبارہ درخواست نہیں دے سکتے، ایپ ایڈمن کی نظرثانی کا انتظار کریں'
  }
}



// WEBPACK FOOTER //
// src/pages/app/find-hostJoin/lang.js